<template>
  <div class="main-center-bottom">
    <div class="msg-character-count d-flex justify-space-between">
      <div class="subtitle-2">{{ noteId == 0 ? "New" : "Edit" }} Note</div>
      <div class="msg-counter">Count: {{ noteValue.trim().length }}</div>
    </div>
    <div class="msg-input">
      <v-card outlined width="100%">
        <v-textarea
          ref="inputNewNote"
          id="inputNewNote"
          name="inputNewNote"
          outlined
          auto-grow
          class="input-textarea-container"
          placeholder="Add an internal note"
          autofocus
          v-model="noteValue"
        >
        </v-textarea>
        <v-toolbar dense flat>
          <!-- <v-menu
            open-on-hover
            top
            offset-y
            v-if="currentCustomer"
            width="300"
            max-width="600"
          >
            <template v-slot:activator="{ on }">
              <v-btn small text color="secondary" class="mx-2" v-on="on"
                ><v-icon left>mdi-text-box-multiple-outline</v-icon
                >Template</v-btn
              >
            </template>
            <v-card>
              <v-card-title>Note Templates</v-card-title>
              <v-card-subtitle
                >These will help you take quick notes</v-card-subtitle
              >
              <v-divider></v-divider>
              <v-list>
                <v-list-item
                  v-for="(item, index) in noteTemplates"
                  :key="index"
                  three-line
                  class="messageTemplateItem"
                  @click="
                    showActionEntry({
                      noteText: item.value
                    })
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      item.value
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu> -->
          <v-spacer></v-spacer>
          <v-btn text bottom small @click="onCancel"> Cancel</v-btn>
          <v-btn
            class="message-send-btn"
            id="messageSubmitBtn"
            @click="onSubmitForm"
            depressed
            bottom
            small
            color="primary"
          >
            Save
          </v-btn>
        </v-toolbar>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoteEntryForm",
  props: {
    msg: String,
    noteId: Number
  },
  data: function() {
    return {
      noteValue: ""
    };
  },
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    currentCustomer() {
      return this.$store.getters["entities/customers/query"]().find(
        this.user.currentCustomerId
      );
    },
    noteTemplateListId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where(type => {
          return type.code == "note_template";
        })
        .get();
      return listType.length > 0 ? listType[0].id : null;
    },
    noteTemplates() {
      let vueThis = this;
      let listItems = this.$store.getters["entities/listItems/query"]()
        .where(item => {
          return item.listTypeId == vueThis.noteTemplateListId;
        })
        .get();
      listItems =
        listItems.length > 0
          ? listItems.sort(
              (a, b) => (a.rank ? a.rank : 0) - (b.rank ? b.rank : 0)
            )
          : [];
      let templates = listItems.map(obj => {
        return {
          name: obj.name,
          value: obj.meta.value
        };
      });
      if (templates.length == 0) {
        templates.push({
          name: "Create your first template in settings",
          value: null
        });
      }
      return templates;
    }
  },
  created() {
    let vueThis = this;
    if (vueThis.noteId != 0) {
      const note = this.$store.getters["entities/notes/query"]().find(
        vueThis.noteId
      );
      vueThis.noteValue = note.note;
    } else {
      vueThis.noteValue = "";
    }
  },
  methods: {
    onSubmitForm(evt) {
      evt.preventDefault();
      const noteVal = this.noteValue.trim();
      if (noteVal == "") {
        return;
      }
      if (this.noteId == 0) {
        const tempId = this.$uuidv4();
        this.$store.dispatch("entities/customers/update", {
          where: this.currentCustomer.id,
          data: {
            viewedAt: Date.now(),
            notes: [
              {
                id: tempId,
                isDirty: true,
                accountId: this.user.accountId,
                note: noteVal,
                userId: this.user.id,
                updatedAt: Date.now()
              }
            ]
          },
          insert: ["notes"]
        });
        this.$store.dispatch("entities/notes/createNote", {
          accountId: this.user.accountId,
          customerId: this.currentCustomer.id,
          id: tempId,
          tempId: tempId,
          isDirty: true,
          note: noteVal,
          userId: this.user.id,
          updatedAt: Date.now()
        });
      } else {
        this.$store.dispatch("entities/customers/update", {
          where: this.currentCustomer.id,
          data: {
            viewedAt: Date.now(),
            notes: [
              {
                accountId: this.user.accountId,
                id: this.noteId,
                isDirty: true,
                note: noteVal,
                userId: this.user.id,
                updatedAt: Date.now()
              }
            ]
          },
          insert: ["notes"]
        });
        this.$store.dispatch("entities/notes/updateNote", {
          accountId: this.user.accountId,
          customerId: this.currentCustomer.id,
          id: this.noteId,
          isDirty: true,
          note: noteVal,
          userId: this.user.id,
          updatedAt: Date.now()
        });
      }

      this.onCancel();
    },
    onCancel() {
      this.$parent.hideEntryForms();
    }
  }
};
</script>

<style scoped lang="stylus"></style>
